/**
 * Offline terminal configuration
 * ------------------------------
 * ECR flow is active only when:
 * 1. REACT_APP_OFFLINE_TERMINAL_ENABLED=true (global feature flag), AND
 * 2. This outlet has CardBiz ECR configured in Outlet Settings (device IP in DB)
 *
 * Outlets without CardBiz keep manual credit card type / ref fields.
 */

type CardBizEcrRow = {
	deviceIP?: string | null;
	isDefault?: boolean | null;
	isActive?: boolean | null;
};

function pickDefaultCardBizEcr(
	records?: CardBizEcrRow[] | null,
): CardBizEcrRow | undefined {
	const active = (records ?? []).filter(r => r.isActive !== false);
	return active.find(r => r.isDefault) ?? active[0];
}

/** Env flag from build / .env.local */
export function isOfflineTerminalEnabled(): boolean {
	return process.env.REACT_APP_OFFLINE_TERMINAL_ENABLED === 'true';
}

/**
 * Use ECR flow when the feature flag is on AND this outlet has a CardBiz ECR terminal.
 */
export function isOfflineTerminalActive(
	cardBizEcrList?: CardBizEcrRow[] | null,
): boolean {
	if (!isOfflineTerminalEnabled()) {
		return false;
	}
	const row = pickDefaultCardBizEcr(cardBizEcrList);
	return Boolean(row && row.deviceIP && String(row.deviceIP).trim());
}

/** URL of the ECR agent on the POS PC (same machine as the browser) */
export function getEcrAgentUrl(): string {
	return (
		process.env.REACT_APP_ECR_AGENT_URL ||
		process.env.REACT_APP_LOCAL_ECR_AGENT_URL ||
		'http://127.0.0.1:9200'
	);
}
